import styled, { css } from "styled-components";
import { theme } from "../../../constants/StyledComponents";

type StyledLinkProps = {
  $underline?: boolean;
  $color?: string;
  $disabled?: boolean;
  $useFillIcon?: boolean;
};
export const StyledLink = styled.a<StyledLinkProps>`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  width: fit-content;
  text-decoration: ${({ $underline }) => ($underline ? "underline" : "none")};

  text-decoration-color: ${({ $disabled, $color: color }) =>
    $disabled ? theme.colors.grey_2 : (color ?? theme.colors.black)};

  & span {
    color: ${({ $disabled, $color: color }) =>
      $disabled ? theme.colors.grey_2 : (color ?? theme.colors.black)};
    white-space: nowrap;
  }

  & svg path {
    ${({ $useFillIcon, $disabled, $color: color }) =>
      $useFillIcon
        ? css`
            fill: ${$disabled
              ? theme.colors.grey_2
              : (color ?? theme.colors.black)};
            stroke: none;
          `
        : css`
            stroke: ${$disabled
              ? theme.colors.grey_2
              : (color ?? theme.colors.black)};
          `}
  }

  &:hover {
    text-decoration-color: ${({ $disabled, $color: color }) =>
      $disabled ? theme.colors.grey_2 : (color ?? theme.colors.purple)};

    & span {
      color: ${({ $disabled, $color: color }) =>
        $disabled ? theme.colors.grey_2 : (color ?? theme.colors.purple)};
    }

    & svg path {
      ${({ $useFillIcon, $disabled, $color: color }) =>
        $useFillIcon
          ? css`
              fill: ${$disabled
                ? theme.colors.grey_2
                : (color ?? theme.colors.purple)};
              stroke: none;
            `
          : css`
              stroke: ${$disabled
                ? theme.colors.grey_2
                : (color ?? theme.colors.purple)};
            `}
    }
  }
`;
